<p-toast></p-toast>
<div class="page-wrapper customer-prospect pb-8">
  <div class="wrap-breadcrumb">
    <div class="container">
      <div class="breadcrumb">
        <div>
          <a style="margin-right: 2px;" routerLink="/">Accueil</a> > Gestion > Mes clients / prospects
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="customer-prospect-inner">
      <div class="wrap-title d-flex align-items-center justify-content-between gap-2">
        <h2 class="title p-0 m-0">MES CLIENTS / PROSPECTS</h2>
        <div *ngIf="userService.hasExtranetAccess('fonctions', 'gestion-fournisseurs')"
          class="group-btn d-flex gap-3 align-items-center">
          <div class="position-relative wrap-btn-cata">
            <button (click)="toggleShow()" class="btn-common btn-catalogue">EXPORTER / IMPORTER
            </button>
            <ul *ngIf="showListBtn" class="wrap-select-btn list-none">
              <li (click)="export()">Exporter des clients</li>
              <li (click)="showDialog()">Importer des clients</li>
            </ul>
          </div>
          <button routerLink="/gestion/customer-prospect/create" class="btn-common">CRÉER</button>
        </div>

        <div *ngIf="!userService.hasExtranetAccess('fonctions', 'gestion-fournisseurs')"
          class="group-btn d-flex gap-3 align-items-center">
          <div class="position-relative wrap-btn-cata">
            <button (click)="export()" class="btn-common btn-catalogue">Exporter des clients
            </button>

          </div>
        </div>
      </div>

      <div class="wrap-tab wrap-form-search">
        <div class="px-2 mb-2">
          <div class="wrap-title-filter d-flex justify-content-between align-items-center pb-1">
            <p class="title mb-0">Recherche avancée</p>
            <button (click)="toggleForm()" class="btn-close">
              <img *ngIf="isShowForm" src="src-adisco/assets/images/icon/close-icon.png" alt="">
              <img *ngIf="!isShowForm" src="src-adisco/assets/images/icon/arrow-down.svg" alt="">
            </button>
          </div>
        </div>
        <form *ngIf="isShowForm" [formGroup]="filterForm" class="w-100">
          <div class="wrap-form row">
            <div class="px-1 py-1 mb-2 col-md-4 col-xl-2">
              <div class="wrap-input">
                <label for="">Code Client</label>
                <input formControlName="code" type="text" placeholder="Code Client" />
              </div>
            </div>
            <div class="px-1 py-1 mb-2 col-md-8 col-xl-10">
              <div class="wrap-input">
                <label for="">Raison sociale</label>
                <input formControlName="companyName" type="text" placeholder="Raison sociale" />
              </div>
            </div>
            <div class="px-1 py-1 mb-2 col-md-4 col-xl-3">
              <div class="wrap-select">
                <label for="">Type de client</label>
                <p-dropdown formControlName="typeOfCustomer" class="w-12" [options]="listTypeUser" optionLabel="label"
                  optionValue="valeur" placeholder="Type de client"></p-dropdown>
              </div>
            </div>
            <div class="px-1 py-1 mb-0 col-md-8 col-xl-5">
              <div class="wrap-select">
                <label for="">Adresse</label>
                <input formControlName="address" type="text" placeholder="Adresse" />
              </div>
            </div>
            <div class="px-1 py-1 mb-0 col-md-12 col-xl-4 d-flex align-items-center justify-content-end gap-2">
              <button (click)="clearFilter()" class="btn-clear">Réinitialiser les filtres</button>
              <button (click)="filter()" class="btn-common btn-search">RECHERCHER</button>
            </div>
          </div>
        </form>
      </div>
      <div class="wrap-table">
        <form [formGroup]="formPagination" class="">
          <div class="wrap-pagination">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div class="wrap-rows">
                Afficher
                <p-dropdown formControlName="rows" (onChange)="filterRows()" class="item-page" [options]="listRows"
                  optionLabel=""></p-dropdown>éléments
              </div>
              <p-paginator *ngIf="totalPages > 1" #paginator1 [ngClass]="{'show-dot': totalPages > 5 }"
                (onPageChange)="onPageChange($event)" [rows]="rows3" [totalRecords]="totalRecords"
                [showFirstLastIcon]="false" [showCurrentPageReport]="false"></p-paginator>
            </div>
          </div>
        </form>
        <p-table class="wrap-table" [value]="listCustomer">
          <ng-template pTemplate="header">
            <tr>
              <th class="font-bold">Code</th>
              <th class="font-bold">Raison sociale</th>
              <th class="font-bold" style="min-width: 250px">Adresse</th>
              <th class="font-bold">
                Type de client
              </th>
              <th class="font-bold" style="max-width: 110px; min-width: 110px; width: 110px;">Actions</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
            <tr>
              <td class="font-bold">{{ item?.code }}</td>
              <td class="">{{ item?.companyName }}</td>
              <td class="">{{ item?.address }}</td>
              <td class="">{{ item?.typeOfCustomer?.labels?.fr_FR }}</td>
              <!-- <td>
                <button style="font-size: 14px;" (click)="toggleShowIcon()"
                  class="d-flex btn-active btn-common px-3 py-1 align-items-center">
                  ACTIONS
                  <img style="width: 15px" [ngStyle]="
                    isShow ? { transform: 'rotate(180deg)' } : {}
                  " class="ml-2" src="/src-adisco/assets/images/icon/arrow-down.svg" alt="" />
                </button>
                <button (click)="delete(item)" class="btn-clear p-1">
                  <img src="src-adisco/assets/images/icon/trash.svg" alt="">
                </button>
              </td> -->
              <td *ngIf="userService.hasExtranetAccess('fonctions', 'gestion-fournisseurs')" alignFrozen="right"
                style="text-align: center">
                <div class="" style="position: relative; width: 110px;">
                  <a class="hover-dropdown" label="Show">
                    <button pButton pRipple icon="pi pi-cog"
                      class="btn-active btn-action btn-common px-3 py-1 align-items-center" tooltipPosition="top"
                      style="font-size: 14px;" (click)="toggleDropdown(rowIndex)">ACTIONS
                      <img style="width: 15px" [ngStyle]="showDropdownArray[rowIndex] ? { transform: 'rotate(180deg)' } : {}
                    " class="ml-2" src="/src-adisco/assets/images/icon/arrow-down.svg" alt="" /></button>
                    <div class="w-100 p-dropdown-active position-absolute" *ngIf="showDropdownArray[rowIndex]"
                      style="text-align: left">
                      <div
                        class=" w-100 ng-trigger ng-trigger-overlayAnimationp-menuitem-icon p-menu p-component p-menu-overlay">
                        <ul role="menu" class="p-menu-list p-resetp-menuitem-icon list-none p-0 m-0">
                          <li class="p-element p-menuitem-icon">
                            <a style="font-size: 13px;" [routerLink]="['/gestion/customer-prospect/edit', item?.id]"
                              class="p-menuitem-link d-block p-2" tabindex="0">
                              <span class="p-menuitem-text">Editer</span></a>
                          </li>
                          <li class="p-element p-menuitem-icon">
                            <a style="font-size: 13px;" (click)="delete(item)" class="p-menuitem-link d-block p-2"
                              target="undefined" tabindex="0">
                              <span class="p-menuitem-text">Supprimer</span>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </a>
                </div>
              </td>
              <td *ngIf="!userService.hasExtranetAccess('fonctions', 'gestion-fournisseurs')">
                <button [routerLink]="['/gestion/customer-prospect/edit', item?.id]" class="btn-clear p-1">
                  <i class="pi pi-eye" style="font-size: 16px; color: #003967; position: relative; top: 3px;"></i>
                </button>
              </td>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
<p-dialog header="Importer à partir d'un fichier CSV, XLS ou XLSX" [modal]="true" [(visible)]="visible"
  [style]="{ width: 'fit-content', 'max-width': '90%' }" (onHide)="onClose()">


  <ng-container *ngIf="records === null">
    <div class="popup-import">
      <p class="open-text">Vous allez effectuer un import des clients</p>
      <div class="wrap-block">
        <p class="mb-2">Avant de réaliser votre import veuillez exporter la trame avant d'importer.</p>
        <p class="mb-2">
          <mat-form-field appearance="outline" style="display:inline-block;width:auto;margin-left:10px;font-size:10px;">
            <mat-label>Type de fichier</mat-label>
            <mat-select name="selectedType" [(ngModel)]="selectedType" disableOptionCentering>
              <mat-option *ngFor="let type of types" [value]="type.value">{{ type.label }}</mat-option>
            </mat-select>
          </mat-form-field>
          <a class="btn-secondary" style="margin-left: 10px;" mat-raised-button (click)="onExportTrameFile()">EXPORTER
            LA TRAME</a>
        </p>
      </div>
      <div class="wrap-block">
        <p class="mb-2">Choisissez un fichier CSV, XLS, ou XLSX</p>
        <p *ngIf="visible">
          <input #filePicker type="file" ng-file-select [hidden]="true" (change)="onImportFile($event)"
            accept=".csv,.xls,.xlsx">
          <button class="btn-secondary" mat-raised-button (click)="filePicker.click()">
            SÉLECTIONNER VOTRE FICHIER
          </button>
          <label class="mx-2" *ngIf="file !== null">{{file.name}}</label>
        </p>
      </div>

      <div class="row">
        <div class="col-lg-6">
          <button type="button" class="btn-secondary-light" mat-raised-button (click)="onCancel()">ANNULER</button>
        </div>
        <div class="col-lg-6 text-end">
          <button [disabled]="!file || inProgress" type="button" class="btn-secondary" mat-raised-button
            (click)="onSubmit()">
            <span *ngIf="inProgress"><mat-spinner [diameter]="14"
                style="display:inline-block;"></mat-spinner>&nbsp;&nbsp;</span>IMPORTER
          </button>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="records !== null">
    <div class="row">
      <p>L'import des données de la table <b>dynamic_legal_entity</b> est terminé</p>
      <br><br>
      <hr>
    </div>

    <div class="row">
      <div class="col">
        <p class="mb-0">Nombre de lignes traitées = {{nbTotal}}</p>
        <p class="mb-0 record-ignored"><b>Nombre de lignes ignorées = {{nbIgnored}}</b></p>
        <p class="mb-0 record-success"><b>Nombre de lignes validées = {{nbSuccess}}</b></p>
        <p class="mb-0 record-warning"><b>Nombre de lignes avec alerte = {{nbWarnings}}</b></p>
        <p class="mb-0 record-error"><b>Nombre de lignes en erreur = {{nbErrors}}</b></p>
        <br>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="records-wrapper">
          <div *ngFor="let record of records">
            <div *ngIf="record.type === 'IGNORED'">
              <p class="mb-0 record-ignored">{{record.row}} : IGNORE</p>
            </div>
            <div *ngIf="record.type === 'WARNING'">
              <p class="mb-0 record-warning">ALERTE [LIGNE {{record.row}} - COLONNE {{record.column}}]
                {{record.message}}</p>
            </div>
            <div *ngIf="record.type === 'ERROR'">
              <p class="mb-0 record-error">ERREUR [LIGNE {{record.row}} - COLONNE {{record.column}}] {{record.message}}
              </p>
            </div>
          </div>
        </div>
        <br>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-3">
        <button type="button" class="btn btn-outline-primary" mat-raised-button (click)="onClose()">FERMER</button>
      </div>
      <div class="col-lg-9">
        <p style="float:right;">
          <button type="button" class="btn-secondary" mat-raised-button (click)="onDownloadReport()">TÉLÉCHARGER LE
            RAPPORT</button>
          <button type="button" class="btn-secondary" mat-raised-button style="margin-left: 10px;"
            (click)="onClose()">VALIDER</button>
        </p>
      </div>
    </div>
  </ng-container>
</p-dialog>
<p-dialog header="EDIT ROW" [modal]="true" [(visible)]="visibleEdit" [style]="{ width: '1100px' }">
  <div class="popup-edit">
    <p class="title">Informations clients</p>
    <form [formGroup]="infoCustomerForm" class="">
      <div class="wrap-form row">
        <div class="mb-2 px-1 py-2 col-xl-3 col-lg-6 col-md-12">
          <div class="wrap-input">
            <label for="">Code</label>
            <input formControlName="code" type="text" placeholder="Code Adhérent" />
          </div>
        </div>
        <div class="mb-2 px-1 py-2 col-xl-5 col-lg-6 col-md-12">
          <div class="wrap-input">
            <label for="">Raison sociale</label>
            <input formControlName="companyName" type="text" placeholder="Raison sociale" />
          </div>
        </div>
        <div class="mb-2 px-1 py-2 col-xl-4 col-lg-6 col-md-12">
          <div class="wrap-input">
            <label for="">SIRET</label>
            <input formControlName="siret" type="text" placeholder="SIRET" />
          </div>
        </div>
        <div class="mb-2 px-1 py-2 col-xl-4 col-lg-6 col-md-12">
          <div class="wrap-select">
            <!-- <label for="">TVA</label>
            <input formControlName="vat" type="text" placeholder="TVA" /> -->
            <label for="">Type de client</label>
            <p-dropdown formControlName="typeOfCustomer" class="w-12" [options]="listTypeUser" optionLabel="label"
              optionValue="id" placeholder="Type de client"></p-dropdown>
          </div>
        </div>
        <div class="mb-2 px-1 py-2 col-xl-5 col-lg-12 col-md-12">
          <div class="wrap-input-file">
            <span>Votre logo</span>
            <div class="d-flex">
              <label for="votre-logo">
                SÉLECTIONNER VOTRE FICHIER
                <input (change)="selectImage($event)" type="file" id="votre-logo">
              </label>
              <a class="name-file ml-1" href="{{logoImage?.url}}">{{ nameFile }}</a>
            </div>
          </div>
        </div>
        <div class="mb-2 px-1 py-2 col-xl-8 col-lg-6 col-md-12">
          <div class="wrap-input">
            <label for="">Adresse</label>
            <input formControlName="address" type="text" placeholder="Adresse" />
          </div>
        </div>
        <div class="mb-2 px-1 py-2 col-xl-4 col-lg-6 col-md-12">
          <div class="wrap-input">
            <label for="">Complément d'adresse</label>
            <input formControlName="additionalAddress" type="text" placeholder="Complément d'adresse" />
          </div>
        </div>
        <div class="mb-2 px-1 py-2 col-xl-3 col-lg-6 col-md-12">
          <div class="wrap-input">
            <label for="">Code postal</label>
            <input formControlName="postcode" type="text" placeholder="Code postal" />
          </div>
        </div>
        <div class="mb-2 px-1 py-2 col-xl-4 col-lg-6 col-md-12">
          <div class="wrap-input">
            <label for="">Ville</label>
            <input formControlName="city" type="text" placeholder="Ville" />
          </div>
        </div>
        <div class="mb-2 px-1 py-2 col-xl-5 col-lg-6 col-md-12">
          <div class="wrap-input">
            <label for="">Pays</label>
            <p-dropdown formControlName="country" class="w-12" [options]="listCountry" optionLabel="label"
              optionValue="label" placeholder="Pays"></p-dropdown>
          </div>
        </div>
        <div class="mb-2 px-1 py-2 col-xl-4 col-lg-6 col-md-12">
          <div class="wrap-input">
            <label for="">Téléphone</label>
            <input formControlName="phone" type="text" placeholder="Téléphone" />
          </div>
        </div>
        <div class="mb-2 px-1 py-2 col-xl-4 col-lg-6 col-md-12">
          <div class="wrap-input">
            <label for="">Fax</label>
            <input formControlName="fax" type="text" placeholder="Fax" />
          </div>
        </div>
        <div class="mb-2 px-1 py-2 col-xl-4 col-lg-6 col-md-12">
          <div class="wrap-input">
            <label for="">E-mail</label>
            <input formControlName="email" type="text" placeholder="E-mail" />
          </div>
        </div>
        <div class="mb-2 px-1 py-2 col-xl-12 col-lg-6 col-md-12">
          <div class="wrap-input">
            <label for="">Site web</label>
            <input formControlName="website" type="text" placeholder="Site web" />
          </div>
        </div>
        <!-- <div class="mb-2 col-xl-4 col-lg-6 col-md-12">
          <div class="wrap-input">
            <label for="">Forme juridique</label>
            <input formControlName="status" type="text" placeholder="Forme juridique" />
          </div>
        </div> -->
      </div>
    </form>
    <div class="d-flex justify-content-end px-2">
      <button (click)="saveUpdateInfoCustomer()" class="btn-common btn-save py-2">ENREGISTRER</button>
    </div>
  </div>
</p-dialog>
<p-dialog header="Supprimer la ligne" [modal]="true" [(visible)]="visibleRow" [style]="{ width: '600px' }">
  <div class="popup-del-row text-center text-lg">
    <p class="text-center font-bold" style="font-size: 25px;">Souhaitez vous supprimer définitivement le client
      <span>{{ currentItemCustomer?.companyName }}</span>
    </p>
    <div class="d-flex justify-content-between">
      <button (click)="closePopup()" class="btn-common btn-cancel py-2">NON</button>
      <button (click)="confirmDelete()" class="btn-common btn-save btn-delete py-2">OUI</button>
    </div>
  </div>
</p-dialog>